var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 9 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.96 4.426v1.97h2.917l-.466 3.032H5.96V17H2.672V9.428H0V6.395h2.672V4.083C2.68 3 2.916 1.873 3.827.99 4.46.377 5.369.017 6.646 0 7.468.01 8.25.082 9 .204v2.583H7.675c-.467-.003-.86.102-1.167.337-.377.301-.546.745-.548 1.302Z",
    fill: "#999"
  })));
};
export default SvgFacebook;